import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Target } from "lucide-react";
import api, { errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const QUICK = [10, 25, 50, 75, 90];

export const probTone = (p) => (p == null ? "text-slate-400" : p >= 70 ? "text-emerald-700" : p >= 30 ? "text-amber-600" : "text-rose-600");

export const ProbabilityEditor = ({ quote, onSaved, testId = "prob" }) => {
  const [v, setV] = useState(quote.probability ?? "");
  useEffect(() => { setV(quote.probability ?? ""); }, [quote.probability, quote.id]);
  const save = async (val) => {
    const n = Number(val);
    if (val === "" || Number.isNaN(n) || n < 0 || n > 100) { toast.error("Possibility harus 0-100%"); return; }
    try {
      await api.patch(`/quotations/${quote.id}/probability`, { probability: n });
      setV(n);
      toast.success(`Possibility menang ${n}% disimpan`);
      onSaved && onSaved(n);
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="flex flex-col gap-1.5" data-testid={`${testId}-editor`}>
      <span className="flex items-center gap-1 text-[11px] font-semibold uppercase tracking-wider text-slate-400"><Target className="h-3.5 w-3.5" />Possibility Menang</span>
      <div className="flex flex-wrap items-center gap-1.5">
        {QUICK.map((p) => (
          <button key={p} type="button" onClick={() => save(p)} data-testid={`${testId}-quick-${p}`}
            className={`rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors ${Number(v) === p && v !== "" ? "border-blue-700 bg-blue-700 text-white" : "border-slate-200 bg-white text-slate-600 hover:border-blue-700 hover:text-blue-800"}`}>
            {p}%
          </button>
        ))}
        <Input type="number" min={0} max={100} className="h-8 w-20 bg-white font-num" value={v} onChange={(e) => setV(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && save(v)} placeholder="0-100" data-testid={`${testId}-input`} />
        <Button size="sm" variant="outline" className="h-8 bg-white" onClick={() => save(v)} data-testid={`${testId}-save`}>Simpan</Button>
      </div>
    </div>
  );
};
